import { createSubscriptionHook } from '~/shared/providers/api/createSubscriptionHook';

export const useAssistantChatEventsSubscription = createSubscriptionHook(
  'assistant.aiChatEvents',
  (params: { chatId: string; beginningAt?: string }) => ({
    assistantChatEvents: {
      __args: {
        chatId: params.chatId,
        beginningAt: params.beginningAt,
      },
      __typename: true,
      chatId: true,
      type: true,
      metadata: true,
      issuedAt: true,
      content: true,
      thinkingStep: true,
      error: true,
      conversationTitle: true,
      toolCall: {
        __typename: true,
        id: true,
        name: true,
        arguments: true,
        result: true,
      },
    },
  }),
  {
    select: ({ assistantChatEvents }) => assistantChatEvents,
  },
);
